import {
  FormCancelButton,
  FormDeleteButton,
  FormSaveButton,
  dialogFunction,
} from 'common/components';
import React from 'react';
const ReportingScheduleFooter = (props) => {
  const {
    setOpenSchedule,
    onDeleteScheduleButton,
    disableSubmitButton,
    onSubmit,
    loading,
  } = props;
  const handleDelete = () => {
    dialogFunction({
      type: 'warn',
      content: `Are you sure you want to delete the download schedule?`,
      okText: 'Delete',
      okButtonProps: {
        type: 'danger',
      },
      onOk: async () => await onDeleteScheduleButton(),
    });
  };
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <FormDeleteButton text='Delete Schedule' onClick={handleDelete} />
      <div>
        <FormCancelButton
          onClick={() => {
            setOpenSchedule && setOpenSchedule(false);
          }}
        />
        <FormSaveButton
          loading={loading}
          onClick={onSubmit}
          disabled={disableSubmitButton}
        />
      </div>
    </div>
  );
};
export default ReportingScheduleFooter;